import "./Hero.css";
import { useEffect, useState } from "react";
import { FaLayerGroup } from "react-icons/fa";
import { FaRankingStar, FaCircleCheck } from "react-icons/fa6";

const SLIDES = ["/capa.png", "/capa02.png", "/capa03.png"];

type HeroProps = {
  animate?: boolean;
};

export default function Hero({ animate = true }: HeroProps) {
  const [active, setActive] = useState(0);

  useEffect(() => {
    // Preload images
    SLIDES.forEach((src) => {
      const img = new Image();
      img.src = src;
    });

    const id = setInterval(() => {
      setActive((s) => (s + 1) % SLIDES.length);
    }, 5000);

    return () => clearInterval(id);
  }, []);
  return (
    <section className={`c-hero${animate ? " c-hero--animate" : ""}`} aria-label="Seção principal">
      <div className="c-hero__inner">
        <div className="c-hero__content">
          <p className="c-hero__eyebrow">
            Criação de sites que impulsionam resultados!
          </p>

          <h1 className="c-hero__title">
            <span>
              <strong className="c-hero__accent">Criação</strong> de{' '}
              <strong className="c-hero__accent">sites</strong> para empresas e{' '}
              <strong className="c-hero__accent">profissionais</strong>
            </span>
            <span>
              que querem presença <strong className="c-hero__accent">digital</strong> clara e{' '}
              <strong className="c-hero__accent">confiável</strong>.
            </span>
          </h1>

          <p className="c-hero__subtitle">
            Sites modernos, rápidos e pensados para o seu negócio.
          </p>

          <a className="c-hero__cta" href="#" role="button">
            Quero um site que traga clientes
          </a>

          <div className="c-hero__highlight" role="note">
            <svg
              className="c-hero__icon"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M20 6L9 17l-5-5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg> 
            <span>Crie o seu site com um programador responsável e experiente</span>
          </div>

          <div className="c-hero__stats">
            <div className="c-hero__stat" aria-hidden="true">
              <FaLayerGroup size={28} className="c-hero__stat-icon" aria-hidden="true" />
              <div>
                <div className="c-hero__stat-title">Projetos reais</div>
                <div className="c-hero__stat-sub">para negócios locais</div>
              </div>
            </div>

            <div className="c-hero__stat" aria-hidden="true">
              <FaRankingStar size={28} className="c-hero__stat-icon" aria-hidden="true" />
              {/* <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                className="c-hero__stat-icon"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
              </svg> */}
              <div>
                <div className="c-hero__stat-title">Experiência prática</div>
                <div className="c-hero__stat-sub">com empresas de diferentes segmentos</div>
              </div>
            </div>

            <div className="c-hero__stat" aria-hidden="true">
              <FaCircleCheck size={28} className="c-hero__stat-icon" aria-hidden="true" />
              <div>
                <div className="c-hero__stat-title">Foco em conversão</div>
                <div className="c-hero__stat-sub">e resultado</div>
              </div>
            </div>
          </div>
        </div>

        <div className="c-hero__media">
          <div className="c-hero__perksOverlay" aria-live="polite">
            <span data-perk="parcelado">
              <FaCircleCheck aria-hidden="true" />
              Pagamento parcelado
            </span>
            <span data-perk="sem-dor">
              <FaCircleCheck aria-hidden="true" />
              Sem dor de cabeça
            </span>
          </div>

          <picture className="c-hero__art" aria-hidden="true">
            {SLIDES.map((src, i) => (
              <img
                key={src}
                src={src}
                alt=""
                loading="lazy"
                decoding="async"
                sizes="(min-width: 1024px) 48vw, 100vw"
                width={1280}
                height={800}
                className={"c-hero__slide" + (i === active ? " c-hero__slide--active" : "")}
              />
            ))}
          </picture>
        </div>
      </div>
    </section>
  );
}
